import './styles.scss'

export const SystemManaged = () => (
  <div className='nh-system-managed'>
    <i
      className='fa fa-lock'
      style={{ fontSize: '28px' }}
    />
  </div>
)
